import { render, staticRenderFns } from "./inspectorChargeStatistics.vue?vue&type=template&id=0c8faa20&scoped=true"
import script from "./inspectorChargeStatistics.vue?vue&type=script&lang=js"
export * from "./inspectorChargeStatistics.vue?vue&type=script&lang=js"
import style0 from "./inspectorChargeStatistics.vue?vue&type=style&index=0&id=0c8faa20&prod&scoped=true&lang=css"
import style1 from "./inspectorChargeStatistics.vue?vue&type=style&index=1&id=0c8faa20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8faa20",
  null
  
)

export default component.exports